import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['popover']

  connect () {
    $('[data-toggle="popover"]').popover({ html: true, content: function () { return $('#popover-content').html() } })
  }
}
